import React, { useRef } from 'react';
var VeltCommentsSidebarV2MinimalActionsDropdownContentMarkAllRead = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-content-mark-all-read-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2MinimalActionsDropdownContentMarkAllRead;
